/* Factory Enduro Parts: "Φτιάξε το πακέτο σου" (sections/mf-bundle-builder.liquid).
   Bike -> one part per slot (only parts that fit) -> cart. Every part gets the line properties _mf_build/_mf_slot,
   which the app discount reads to give the % off when enough slots are filled. */
(() => {
  const root = document.querySelector('[data-mf-bb]');
  if (!root) return;
  const KEY = 'mf-bike';   // same saved bike as the finder (assets/mf-finder.js)
  const TOP = ['KTM', 'Husqvarna', 'GASGAS', 'Beta', 'Sherco', 'TM', 'Fantic', 'Honda', 'Yamaha', 'Kawasaki', 'Suzuki'];
  const percent = Number(root.dataset.percent);
  const min = Number(root.dataset.min);
  const $ = (s) => root.querySelector(s);
  const [make, model, year] = ['make', 'model', 'year'].map((n) => $(`[data-bb-${n}]`));
  const slots = [...root.querySelectorAll('.mf-bb__slot')];
  const add = $('[data-bb-add]');
  const thisYear = new Date().getFullYear();
  const isAll = (md) => /^all models?$/i.test(md);
  const natural = (a, b) => a.localeCompare(b, undefined, { numeric: true, sensitivity: 'base' });
  const opt = (value, label) => Object.assign(document.createElement('option'), { value, textContent: label ?? value });
  const money = (cents) => new Intl.NumberFormat('el-GR', { style: 'currency', currency: root.dataset.currency || 'EUR' }).format(cents / 100);
  const saved = () => { try { return JSON.parse(localStorage.getItem(KEY) || 'null'); } catch { return null; } };
  const save = (b) => { try { localStorage.setItem(KEY, JSON.stringify(b)); } catch {} };

  // products of a slot collection, all pages (collection.mf-builder.liquid)
  const cache = {};
  const products = (handle) => (cache[handle] ||= (async () => {
    const get = (p) => fetch(`/collections/${handle}?view=mf-builder&page=${p}`).then((r) => r.json());
    const first = await get(1);
    const rest = await Promise.all(Array.from({ length: first.pages - 1 }, (_, i) => get(i + 2)));
    return [first, ...rest].flatMap((d) => d.products);
  })().catch(() => []));

  const fits = (p, b) => {
    const mk = b.mk.toUpperCase();
    const inYears = (y) => y === '*' || String(y).split(', ').some((r) => { const [a, z = a] = r.split('-').map(Number); return +b.y >= a && +b.y <= z; });
    return (p.f || []).some((r) => r.mk === mk && (r.md === b.md || isAll(r.md)) && inYears(r.y));
  };

  let data = {};
  const bike = () => (make.value && model.value && year.value ? { mk: make.value, md: model.value, y: year.value, h: data[make.value]?.[model.value]?.h } : null);

  function fillModels() {
    model.length = 1; year.length = 1; year.disabled = true;
    const models = Object.keys(data[make.value] || {}).filter((m) => !isAll(m)).sort(natural);
    models.forEach((m) => model.append(opt(m)));
    model.disabled = !models.length;
  }
  function fillYears() {
    year.length = 1;
    const entry = data[make.value]?.[model.value];
    if (!entry) { year.disabled = true; return; }
    const years = entry.y === '*' ? Array.from({ length: thisYear + 2 - 1995 }, (_, i) => thisYear + 1 - i) : entry.y;
    years.forEach((y) => year.append(opt(String(y))));
    year.disabled = false;
  }

  async function fillSlots() {
    const b = bike();
    $('[data-bb-slots]').hidden = !b;
    $('[data-bb-hint]').hidden = !!b;
    if (!b) return update();
    save(b);
    await Promise.all(slots.map(async (el) => {
      const pick = el.querySelector('[data-bb-pick]');
      const keep = pick.value;
      pick.disabled = true; pick.length = 0; pick.append(opt('', 'Φόρτωση…'));
      const list = (await products(el.dataset.handle)).filter((p) => fits(p, b));
      pick.length = 0;
      pick.append(opt('', list.length ? `Δεν θέλω (${list.length} ταιριάζουν)` : 'Δεν βρέθηκε κάτι για τη μηχανή σου'));
      el._items = {};
      list.sort((x, y) => x.v[0].p - y.v[0].p).forEach((p) => p.v.forEach((v) => {
        el._items[v.id] = { p, v };
        pick.append(opt(String(v.id), `${p.t}${p.v.length > 1 ? ' · ' + v.t : ''} – ${money(v.p)}`));
      }));
      pick.disabled = !list.length;
      if (keep && el._items[keep]) pick.value = keep;
      el.classList.toggle('is-empty', !list.length);
      showPick(el);
    }));
    update();
  }

  function showPick(el) {
    const it = el._items?.[el.querySelector('[data-bb-pick]').value];
    const img = el.querySelector('[data-bb-img]');
    const link = el.querySelector('[data-bb-link]');
    img.innerHTML = it?.p.img ? `<img src="${it.p.img}" alt="" loading="lazy" width="120" height="120">` : '';
    link.hidden = !it; if (it) link.href = it.p.u;
    el.classList.toggle('is-picked', !!it);
  }

  const picked = () => slots.map((el) => ({ slot: el.dataset.slot, it: el._items?.[el.querySelector('[data-bb-pick]').value] })).filter((x) => x.it);

  function update() {
    const list = bike() ? picked() : [];
    const total = list.reduce((s, x) => s + x.it.v.p, 0);
    const ok = list.length >= min;
    const save = ok ? Math.round(total * percent / 100) : 0;
    $('[data-bb-count]').textContent = `${list.length} / ${min}`;
    $('[data-bb-total]').textContent = list.length ? money(total) : '–';
    $('[data-bb-save]').textContent = ok ? `-${money(save)}` : '–';
    $('[data-bb-final]').textContent = list.length ? money(total - save) : '–';
    const status = $('[data-bb-status]');
    status.textContent = ok ? `Τέλεια! Παίρνεις -${percent}% σε όλο το πακέτο.` : `Διάλεξε ακόμη ${min - list.length} ${min - list.length === 1 ? 'κομμάτι' : 'κομμάτια'} για την έκπτωση.`;
    status.classList.toggle('is-ok', ok);
    add.disabled = !ok;
  }

  add.addEventListener('click', async () => {
    const list = picked();
    if (list.length < min) return;
    add.disabled = true;
    const build = Date.now().toString(36) + Math.random().toString(36).slice(2, 6);
    const r = await fetch('/cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: list.map((x) => ({ id: x.it.v.id, quantity: 1, properties: { _mf_build: build, _mf_slot: x.slot } })) }),
    }).catch(() => null);
    if (r?.ok) { location.href = '/cart'; return; }
    const err = await r?.json().catch(() => null);
    $('[data-bb-status]').textContent = err?.description || 'Κάτι πήγε στραβά – δοκίμασε ξανά.';
    add.disabled = false;
  });

  make.addEventListener('change', () => { fillModels(); fillSlots(); });
  model.addEventListener('change', () => { fillYears(); fillSlots(); });
  year.addEventListener('change', fillSlots);
  slots.forEach((el) => el.querySelector('[data-bb-pick]').addEventListener('change', () => { showPick(el); update(); }));

  fetch(root.dataset.bikes).then((r) => r.json()).catch(() => ({})).then((d) => {
    data = d;
    Object.keys(data).sort((a, b) => {
      const ia = TOP.indexOf(a), ib = TOP.indexOf(b);
      return (ia < 0 ? 99 : ia) - (ib < 0 ? 99 : ib) || natural(a, b);
    }).forEach((m) => make.append(opt(m)));
    const b = saved();
    if (b && data[b.mk]?.[b.md]) {
      make.value = b.mk; fillModels(); model.value = b.md; fillYears();
      if (b.y) year.value = b.y;
    }
    fillSlots();
  });
})();
